<template>
    <div class="flex flex-col">
        <header-component :isMobile="isMobile"></header-component>
        <main>
            <router-view :isMobile="isMobile" />
        </main>
        <WhatsAppNotification v-show="isMobile" />
        <footer-component :isMobile="isMobile"></footer-component>
    </div>
</template>

<script>
import { reactive, toRefs } from '@vue/composition-api';
import { setAlert } from '@/composibles/notification';
import Header from '@/layouts/header';
import Footer from '@/layouts/footer';
import WhatsAppNotification from '@/components/whatsapp';

export default {
    components: {
        'header-component': Header,
        'footer-component': Footer,
        WhatsAppNotification,
    },
    name: 'Default',
    setup(_, { root }) {
        let self = reactive({ isMobile: false });
        window.addEventListener('resize', () => {
            self.isMobile = window.innerWidth <= 768;
        });
        self.isMobile = window.innerWidth <= 768;

        setAlert(root.$swal);

        return { ...toRefs(self) };
    },
};
</script>
<style lang="scss" scoped></style>
